import { getListingApplicants, getListingFilteredApplicants, getResume, getAssessment } from "api/@teams/applicants"

export const platformTeamsFetchListingApplicants = () => {
  return async (dispatch) => {
    const data = await getListingApplicants()
    if (!data.error) {
      dispatch({ type: "TEAMS_UPDATE_APPLICANTS", data })
    }
  }
}

export const platformTeamsFetchListingFilteredApplicants = (keywords) => {
  return async (dispatch) => {
    dispatch({ type: "TEAMS_TOGGLE_FILTER_LOADING", data: true })
    // console.log(keywords)
    const data = await getListingFilteredApplicants(keywords)
    if (!data.error) {
      dispatch({ type: "TEAMS_UPDATE_APPLICANTS", data })
      dispatch({ type: "TEAMS_TOGGLE_FILTER_LOADING", data: false })
    }
  }
}

export const platformTeamsFetchResume = () => {
  return async (dispatch) => {
    const data = await getResume()
    if (!data.error) {
      dispatch({
        type: "TEAMS_UPDATE_RESUME",
        data: {
          ...data,
          templateList: undefined
        }
      })
      dispatch({
        type: "TEAMS_UPDATE_TEMPLATE_LIST",
        data: data.templateList
      })
    }
  }
}

export const platformTeamsFetchAssessment = () => {
  return async (dispatch) => {
    const data = await getAssessment()
    if (!data.error) {
      dispatch({ type: "TEAMS_UPDATE_ASSESSMENT", data })
    }
  }
}
